import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { NameSpace } from '../../const';
import { SummaryData } from '../../types/state';
import { FetchDataSummaryParams, FetchDataSummarySuccessPayload } from '../../types/request';
import { buildDataSummary } from '../../utils/data-table';

const initialState: SummaryData = {
  data: null,
  fetchingStatusSummaryData: false,
  error: null
};

export const dataSummaryVPO = createSlice({
  name: NameSpace.DataSummary,
  initialState,
  reducers: {
    fetchDataSummaryRequestVPO: (state, payload: PayloadAction<FetchDataSummaryParams>) => {
      state.fetchingStatusSummaryData = true;
    },
    fetchDataSummarySuccessVPO: (state, action: PayloadAction<FetchDataSummarySuccessPayload>) => {
      const { data, params } = action.payload;
      state.data = buildDataSummary(data, params.month, params.year, params.group);
      state.fetchingStatusSummaryData = false;
    },
  },
});

export const { fetchDataSummaryRequestVPO, fetchDataSummarySuccessVPO } = dataSummaryVPO.actions;
